import Api from "../../api/index";

const ActionPlan = {
  namespaced: true,
  state: {
    allMyActionPlans: null,
    oneActionPlan: null,
    loadingActionPlans: false,
  },
  getters: {
    sentByMe: (state, getters, rootState) => {
      if (state.allMyActionPlans && state.allMyActionPlans.data) {
        return state.allMyActionPlans.data
          .map((o) => o.attributes)
          .filter((item) => item.emitter_id == rootState.User.oneUser.employee.id);
      }
    },
    sentToMe: (state, getters, rootState) => {
      if (state.allMyActionPlans && state.allMyActionPlans.data) {
        return state.allMyActionPlans.data
          .map((o) => o.attributes)
          .filter((item) =>
            item.receiver_ids.includes(rootState.User.oneUser.employee.id)
          );
      }
    },
  },
  mutations: {
    setAllMyActionPlans(state, allMyActionPlans) {
      state.allMyActionPlans = allMyActionPlans; //.data.map(o=>o.attributes)
    },
    setOneActionPlan(state, payload) {
      state.oneActionPlan = payload; //.data.map(o=>o.attributes)
    },
    setLoadingActionPlans(state, payload) {
      state.loadingActionPlans = payload;
    },

    setCommentCount(state, comment_count){
      // console.log('vaaaii');
      if (state.oneActionPlan){
        // console.log('vaaaii action plaann');
        state.oneActionPlan.data.attributes.comments_count = comment_count
      }
    }
  },
  actions: {
    getOneActionPlan(context, id) {
      context.commit("setLoadingActionPlans", true);
      setTimeout(() => {
        Api.ActionPlan.show(id)
          .then((response) => response.data)
          .then((oneActionPlan) => {
            context.commit("setOneActionPlan", oneActionPlan);
            context.commit("setLoadingActionPlans", false);
          })
          .catch(function(error) {
            context.commit("setLoadingActionPlans", false);
            console.log(error);
          });
      }, 1500);
    },
    getAllMyActionPlans(context, filter) {
      context.commit("setLoadingActionPlans", true);
      context.commit("setAllMyActionPlans", null);
      setTimeout(() => {
        Api.ActionPlan.index(filter)
          .then((response) => response.data)
          .then((allMyActionPlans) => {
            context.commit("setAllMyActionPlans", allMyActionPlans);
            context.commit("setLoadingActionPlans", false);
          })
          .catch(function(error) {
            context.commit("setLoadingActionPlans", false);
            console.log(error);
          });
      }, 1500);
    },
  },
};

export default ActionPlan;
